import * as React from 'react';

import styles from './new-badge.module.css';

export function NewBadge() {
    return <div className={styles.container}>New!</div>;
}
